import React, { useState } from "react";
import { Tab } from "@headlessui/react";
import GenerateTax from "./GenerateTax";
import TaxReport from "./TaxReport";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function TaxTabs() {
  const [categories] = useState({
    "Gerar Impostos": <GenerateTax />,
    Relatórios: <TaxReport />,
  });

  return (
    <div className="w-full max-w-7xl mx-auto px-2 py-8 sm:px-0">
      <Tab.Group>
        <Tab.List className="flex space-x-1 rounded-xl bg-slate-800 p-1 mb-6 border border-slate-700/50">
          {Object.keys(categories).map((category) => (
            <Tab
              key={category}
              className={({ selected }) =>
                classNames(
                  "w-full rounded-lg py-2.5 text-sm font-medium leading-5 transition-all duration-200",
                  "focus:outline-none focus:ring-2 ring-offset-2 ring-offset-slate-900 ring-indigo-500",
                  selected
                    ? "bg-slate-700 text-white shadow-md border border-slate-600"
                    : "text-slate-400 hover:bg-slate-700/50 hover:text-slate-200"
                )
              }
            >
              {category}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          {Object.entries(categories).map(([category, component], idx) => (
            <Tab.Panel
              key={idx}
              className={classNames(
                "mt-6 focus:outline-none"
              )}
            >
              {component}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}
